// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Layout from "../../shared/Layout.re.mjs";
import * as IdeaList from "../../organisms/IdeaList.re.mjs";
import * as Core from "@linaria/core";
import * as JsxRuntime from "react/jsx-runtime";
import * as ReactHelmetAsync from "react-helmet-async";

import { css, cx } from '@linaria/core'
;

let items = [
  {
    id: "royal-portraits",
    name: "Classical Royal Portraits",
    description: "Sometimes called a Face Swap painting, a royal portrait is like a classical reproduction painting except you can wap out the people's faces, or even entire bodies, for those of yourself or your friends. It's even possible to add someone or something, such as your favorite pet sitting beside you. To get this made just upload a picture of your favorite painting along with headshots of the people you want swapped in. Make sure the headshots (or body shots) are in matching or suitable orientations for the process to go smoothly.",
    price: 0,
    image: {
      src: "https://images.instapainting.com/5fb4e32787456f55618b456d_w0.jpg?fit=crop&crop=focalpoint&fp-z=1.1&fp-y=0.32&ar=1",
      alt: "Brown leather key ring with brass metal loops and rivets on wood table.",
      imgixParams: undefined
    },
    link: "/products/gallery/custphotoreal/5fa6f28187456fe3238b4581/?order=1"
  },
  {
    id: "merge-photos",
    name: "Make a Scene",
    description: "Provide a background to use, and pictures of people or pets to add to the scene. For best results, take photos of the people specifically for this custom painting commission. That means their poses and orientations should match the background scene. The artist can add shadows and smooth out the kinks.",
    price: 0,
    image: {
      src: "https://images.instapainting.com/61b9ae0c705402c8108b4572.jpg",
      alt: "Oil painting of a sunset with some kids in the foreground looking at it.",
      imgixParams: {
        fit: "crop",
        crop: "focalpoint"
      }
    },
    link: "/products/gallery/custphotoreal/61a7e08c50a069a2068b4575/?order=1"
  },
  {
    id: "kitsch",
    name: "Kitschy Portraits",
    description: "The term \"kitsch\" is reserved for art that is done in poor taste, ironic, or humorous. One of the most famous examples of kitsch is the painting \"A Friend in Need\" of dogs playing poker. You can take that painting and substitute one of those dogs for your dog, or create something complete new like this painting of a dog as Captain Marvel.",
    price: 0,
    image: {
      src: "https://images.instapainting.com/61d9ac8a183a3eee218b4570_w0.jpg?fit=crop&crop=focalpoint&fp-z=1.45",
      alt: "Kitschy oil portrait of a dog as Captain Marvel",
      imgixParams: {
        fit: "crop",
        crop: "focalpoint",
        "fp-z": "1.25"
      }
    },
    link: "/products/gallery/custphotoreal/6191b9203f4a8a42048b459b/?order=1"
  },
  {
    id: "reunite",
    name: "Reunite Lost Loved Ones",
    description: "Artists can paint people from separate photos together into one painting as if they were next to each other. Grandparents can be with the grandchildren they never met. If your family is spread apart and cannot be together for a group portrait, individual photos of everyone can me combined into a group painting.",
    price: 0,
    image: {
      src: "https://images.instapainting.com/5a3ab6ac87456f282a8b4588.jpg",
      alt: "Oil painting portrait of a man and his grandmother on a brown background.",
      imgixParams: {
        fit: "crop",
        crop: "focalpoint",
        "fp-z": "1.25"
      }
    },
    link: "/products/gallery/custphotoreal/5a25f1c787456f6e198b45af?order=1"
  }
];

function Ideas_Page(props) {
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsxs(ReactHelmetAsync.Helmet, {
        children: [
          JsxRuntime.jsx("title", {
            children: "Ideas to Customize Your Photo to Painting"
          }),
          JsxRuntime.jsx("meta", {
            content: "Customize your custom photo to painting order with arbitrary instructions. Paint yourself into a classic portrait, ride a dinosaur, be a superhero, remove the unwated object or person, or reunite with lost loved ones in the form of a portrait painting.",
            name: "description"
          })
        ]
      }),
      JsxRuntime.jsx(Layout.Container.make, {
        children: JsxRuntime.jsx(IdeaList.make, {
          title: "Ideas to Customize Your Painting",
          subtitle: "Make your artwork truly unique",
          description: "Because each order is hand-crafted by a real human artist, they can take arbitrary instruction and customize your painting in creative ways. All you have to do is provide the right reference photos and instructions.",
          items: items
        }),
        className: Core.cx("mb-16", "py-8", "lg:py-16")
      })
    ]
  });
}

let make = Ideas_Page;

let $$default = Ideas_Page;

export {
  items,
  make,
  $$default as default,
}
/*  Not a pure module */
